import classNames from 'classnames';
import { createRef, PureComponent } from 'react';

import { pluginPresets, SolutionStepsEditor } from 'my-editor';
import Editor from 'my-editor/EditorError';

import ClickAwayListener from '@mui/material/ClickAwayListener';

export default class NestedEditor extends PureComponent {
  state = {};
  editor = createRef();

  componentDidMount() {
    const { block, blockProps } = this.props;
    if (block.getKey() === blockProps.focusedBlockKey) {
      this.editor.current.focus();
    }
  }

  getEntityData(contentState, block) {
    return contentState.getEntity(block.getEntityAt(0)).getData();
  }

  handleContentUpdate = content => {
    const { block, blockProps, contentState } = this.props;
    const entityKey = block.getEntityAt(0);
    const updatedContentState = contentState.mergeEntityData(entityKey, { content });
    blockProps.onUpdateContentState(updatedContentState);
  };

  focus = e => {
    e.preventDefault();
    const { block, blockProps } = this.props;
    blockProps.onFocus('EDITOR', block.getKey());
  };

  blur = e => {
    if (!e.defaultPrevented) {
      const { blockProps } = this.props;
      blockProps.onBlur();
    }
  };

  toggleNestedEditorFocus = focused => this.setState({ nestedEditorFocus: focused });

  render() {
    const { block, blockProps, className, contentState } = this.props;
    const { onToggleSolutionKey, onUpdateToolbarProps, readOnly, reportLatexErrors, showSolutions } = blockProps;
    const { nestedEditorFocus } = this.state;
    const active = block.getKey() === blockProps.focusedBlockKey;
    const { content } = this.getEntityData(contentState, block);
    const editor =
      readOnly && onToggleSolutionKey ?
        <SolutionStepsEditor
          blockSolutionClassName="NE-solutionBlock"
          css={rootCss}
          decoratorProps={{
            solutionToggleClassName: 'NE-solutionBlock',
            solutionVisibleClassName: 'NE-solutionBlock',
          }}
          editorClassName={className}
          onToggleSolutionKey={onToggleSolutionKey}
          showSolutions={showSolutions}
          value={content}
        />
      : <Editor
          canToggleSolutions
          className={classNames(className, { 'NE-editable': !readOnly })}
          css={rootCss}
          decoratorProps={{
            solutionToggleClassName: 'NE-solutionBlock',
            solutionVisibleClassName: 'NE-solutionBlock',
          }}
          onChange={this.handleContentUpdate}
          onMouseDown={readOnly || active ? undefined : this.focus}
          onToggleNestedEditorFocus={this.toggleNestedEditorFocus}
          onUpdateToolbarProps={onUpdateToolbarProps}
          plugins={pluginPresets.ALL}
          readOnly={!active}
          ref={this.editor}
          reportLatexErrors={reportLatexErrors}
          showSolutions={!readOnly || showSolutions}
          value={content}
        />;
    if (readOnly) return editor;
    return (
      <ClickAwayListener
        mouseEvent={active && !nestedEditorFocus && 'onMouseDown'}
        onClickAway={this.blur}
        touchEvent={active && 'onTouchEnd'}
      >
        {editor}
      </ClickAwayListener>
    );
  }
}

const solutionStyles = { backgroundColor: 'rgba(0,0,0,0.05) !important' };
const rootCss = ({ palette, shape: { borderRadius }, spacing }) => ({
  '& .Editor-solutionBlock': solutionStyles,

  '&.NE-editable': {
    padding: spacing(1),
    border: `1px solid ${palette.grey[400]}`,
    borderRadius,
  },

  '&.NE-solutionBlock, .NE-solutionBlock': {
    ...solutionStyles,
    '&:hover': { backgroundColor: 'rgba(0,0,0,0.1) !important' },
  },
});
